module.exports = __webpack_public_path__ + "static/media/Kevin_Liu.dfe01f87.png";